export const productCardsDesktopParams = {
  rows: 1,
  columns: 5,
  imageAspectRatio: 168 / 252,
  verticalGutter: 16,
  horizontalGutter: 16,
  textHeight: 40,
};

export const productCardsMobileParams = {
  rows: 2,
  columns: 2,
  imageAspectRatio: 168 / 267,
  verticalGutter: 16,
  horizontalGutter: 16,
  textHeight: 40,
};
